import { Coins, Landmark, Wallet } from "lucide-react";
import Button from "../../ui/button/Button";
import { Modal } from "../../ui/modal";
import { useCurrencyStore } from "../../../stores/useCurrencyStore";

interface PaymentLinkSelectMethodProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (methodType: 'WALLET' | 'TRANSFER' | 'STABLE_CURRENCY' | 'WECHAT_PAY' | 'ALIPAY') => void;
  title: string;
  currency: string;
}

export function PaymentLinkSelectMethod({
  isOpen,
  onClose,
  onSelect,
  title,
  currency,
}: PaymentLinkSelectMethodProps) {
  const { getCurrencyByCode } = useCurrencyStore();
  const currencyDetails = getCurrencyByCode(currency);
  const isStableCurrency = currencyDetails?.paymentMethod?.stableCurrency;
  const isCNY = currency === "CNY";

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-md">
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-6">
          {title} - {currency}
        </h3>

        <div className="space-y-4">
          {isStableCurrency ? (
            <Button
              variant="outline"
              className="w-full justify-center gap-2"
              onClick={() => onSelect("STABLE_CURRENCY")}
            >
              <Coins className="h-5 w-5" />
              Stable Coin
            </Button>
          ) : (
            <>
              <Button
                variant="outline"
                className="w-full justify-center gap-2"
                onClick={() => onSelect("TRANSFER")}
              >
                <Landmark className="h-5 w-5" />
                Bank Transfer / Mobile Money
              </Button>

              {isCNY && (
                <>
                  <Button
                    variant="outline"
                    className="w-full justify-center gap-2"
                    onClick={() => onSelect("WECHAT_PAY")}
                  >
                    <Wallet className="h-5 w-5" />
                    WeChat Pay
                  </Button>

                  <Button
                    variant="outline"
                    className="w-full justify-center gap-2"
                    onClick={() => onSelect("ALIPAY")}
                  >
                    <Wallet className="h-5 w-5" />
                    Alipay
                  </Button>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
}